<section class="form">
  <header class="form__section form__section_header">
    <app-header title="{{'Shipping Method' | translate}}"></app-header>
  </header>
  <form class="form__section form__section_content">
    <app-toggle-cards
      class="cards"
      *ngIf="!(discountService.activeDiscountCampaignsObservable | async)"
      [(value)]="i"
    >
      <app-toggle-cards-item translate class="cards__item"
        *ngFor="let s of shippings; index as i"
        [name]="s.name"
        [description]="s.description"
        [price]="{
          value: s.price,
          currency: s.currency
        }"
        [value]="i"
        [disabled]="checkDisabled(s)"
      ></app-toggle-cards-item>
    </app-toggle-cards>
    <app-toggle-cards
      class="cards"
      *ngIf="(discountService.activeDiscountCampaignsObservable | async) as discountCampaign"
      [(value)]="i"
    >
      <app-toggle-cards-item translate class="cards__item"
        *ngFor="let s of shippings; index as i"
        [name]="s.name"
        [description]="s.description"
        [price]="{
          value: s.price,
          currency: s.currency
        }"
        [value]="i"
        [disabled]="checkDisabled(s)"
        [discount]="getShippingDiscount(discountCampaign, FEToBEShipping(s))"
      ></app-toggle-cards-item>
    </app-toggle-cards>
  </form>
  <div class="form__section form__section_message">
    <app-section-message-date
      size="lg"
    ></app-section-message-date>
  </div>
</section>
